<template>
  <div class="bg-white rounded-sm m-2">
    <b-row>
      <b-modal title="Application Details" ref="applicationDetails" size="xl" hide-footer>
        <SocietyIncorporationDetails :tracking-number="trackingNumber"/>
      </b-modal>
    </b-row>
    <b-row>
      <b-col cols="12" class="mx-3 mt-3">
        <b-row>
          <span class="title">Building Society Incorporation Applications</span>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="flex mx-3 mt-3">
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="pre-waiting">
          <span v-if="getBSIncorporationStatistics.draft === undefined" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto">{{getBSIncorporationStatistics.draft}}</span>
        </div>
        <div class="pre-waiting">
          <span class="text-sm mx-auto">Drafts</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="waiting">
          <span v-if="getBSIncorporationStatistics.pending === undefined" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto">{{getBSIncorporationStatistics.pending}}</span>
        </div>
        <div class="waiting">
          <span class="text-sm mx-auto">In Queue</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="normal">
          <span v-if="getBSIncorporationStatistics.assigned === undefined" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto">{{getBSIncorporationStatistics.assigned}}</span>
        </div>
        <div class="normal">
          <span class="text-sm mx-auto">Assigned</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="off-normal">
          <span v-if="getBSIncorporationStatistics.escalated === undefined" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto">{{getBSIncorporationStatistics.escalated}}</span>
        </div>
        <div class="off-normal">
          <span class="text-sm mx-auto">Escalated</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="warning">
          <span v-if="getBSIncorporationStatistics.queried === undefined" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto">{{getBSIncorporationStatistics.queried}}</span>
        </div>
        <div class="warning">
          <span class="text-sm mx-auto">Queried</span>
        </div>
      </div>

      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="positive">
          <span v-if="getBSIncorporationStatistics.approved === undefined" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto">{{ getBSIncorporationStatistics.approved }}</span>
        </div>
        <div class="positive">
          <span class="text-sm mx-auto">Registered</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="all">
          <span v-if="getBSIncorporationStatistics.total === undefined" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto">{{ getBSIncorporationStatistics.total }}</span>
        </div>
        <div class="all">
          <span class="text-sm mx-auto">Total</span>
        </div>
      </div>
    </b-row>
    <b-row class="flex">
      <b-col cols="12">
        <b-row class="pt-3">
          <b-col>
            <AllBuildingSocietyIncorporationSubmissions :status="null" v-on:openDetails="openDetails" />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import SocietyIncorporationDetails
  from "@/views/home/services/bsi_incorporation/submissions/SocietyIncorporationDetails";
import AllBuildingSocietyIncorporationSubmissions
  from "@/views/home/services/bsi_incorporation/submissions/AllBuildingSocietyIncorporationSubmissions";

export default {
  name: "BuildingSocietyIncorporationApplications",
  components: {
    AllBuildingSocietyIncorporationSubmissions,
    SocietyIncorporationDetails
  },
  data(){
    return{
      currentRoute: "pending",
      trackingNumber:null,
    }
  },
  mounted(){
    this.fetchBSStatistics()
  },
  methods:{
    ...mapActions(["fetchBSStatistics"]),
    select(route){
      this.currentRoute = route
    },
    openDetails(trackingNumber){
      this.trackingNumber = trackingNumber
      this.$refs.applicationDetails.show()
    }
  },
  computed:{
    ...mapGetters(["getBSIncorporationStatistics"])
  }
}
</script>

<style scoped>
@import "../../../../../assets/styles/menu.css";

.pre-waiting{
  @apply flex text-gray_title;
}

.off-normal{
  @apply flex text-blue-light;
}

.waiting{
  @apply flex text-gray;
}

.normal{
  @apply flex text-blue;
}

.positive{
  @apply flex text-green;
}

.warning{
  @apply flex text-orange;
}

.all{
  @apply flex text-flopurple;
}

.stat-count{
  display: inline;
  width: 12%;
  @apply my-1;
}
</style>